/**
 * SoleadLab 2.0 — Detection job poller (P2a scan dispatch)
 *
 * Drives detectionStore.refreshJob() while a job is non-terminal. Mounted
 * ONCE in EditorPage (same placement as useTileStatusPoller). The store owns
 * overlap-guarding (_refreshInFlight) and all terminal-state handling — this
 * hook is only the clock: one immediate tick when a job starts, then every
 * POLL_INTERVAL until the job leaves pending/running.
 *
 * Note: each GET is also what applies the server's R2 completion marker and
 * lazy watchdog (see soleadlab-api handlers/detections.ts) — without a
 * poller attached, a job never transitions.
 */

import { useEffect } from 'react';
import { useDetectionStore } from '../stores/detectionStore';

const POLL_INTERVAL = 5000; // ms — matches useTileStatusPoller cadence

export default function useDetectionPoller() {
  const jobId = useDetectionStore((s) => s.job?.id ?? null);
  const status = useDetectionStore((s) => s.job?.status ?? null);
  const active = status === 'pending' || status === 'running';

  useEffect(() => {
    if (!jobId || !active) return;
    // refreshJob never rejects (errors are handled in-store), but keep the
    // promise explicitly discarded for lint clarity.
    const tick = () => {
      void useDetectionStore.getState().refreshJob();
    };
    tick(); // immediate first tick so a fast job isn't stuck a full interval
    const timer = setInterval(tick, POLL_INTERVAL);
    return () => clearInterval(timer);
  }, [jobId, active]);
}
